var Settings = function Settings() {
  this.defaultBlock = 'latest';
  this.defaultAccount = undefined;
};
module.exports = Settings;